import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { EmployeeOptionsService } from '../services/employee-options-service';
import { EmployeeOptionsStatement as EmployeeOptionsData } from '../types/employee-statement';
import { EmployeeOptionsStatement } from '../components/EmployeeOptionsStatement';

interface MyOptionsPageProps {
  employeeId?: number;
  isGhosting?: boolean;
}

export const MyOptionsPage: React.FC<MyOptionsPageProps> = ({ employeeId, isGhosting = false }) => {
  const [optionsData, setOptionsData] = useState<EmployeeOptionsData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        setIsLoading(true);
        setError(null);

        if (isGhosting && employeeId) {
          // When ghosting, fetch specific employee's options (admin viewing via MyOptions endpoints)
          const data = await EmployeeOptionsService.getEmployeeOptionsForActivityViaMyOptions(employeeId);
          setOptionsData(data);
        } else {
          // Normal mode - fetch current user's options
          const data = await EmployeeOptionsService.getMyOptionsForActivity();
          setOptionsData(data);
        }
      } catch (err) {
        console.error('Error loading options:', err);
        setError('Failed to load options data. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, [employeeId, isGhosting]);

  if (error) {
    return (
      <Container>
        <Row>
          <Col>
            <div className="alert alert-danger mt-3">
              {error}
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      {optionsData && (
        <EmployeeOptionsStatement
          data={optionsData}
          isLoading={isLoading}
        />
      )}
      {isLoading && !optionsData && (
        <Row>
          <Col>
            <div className="text-center p-4">Loading...</div>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default MyOptionsPage;
